module.exports = __webpack_public_path__ + "static/media/b-sci-major-25_LR.66db09ec.jpg";